import React from 'react';
import "./loading.css"

const Loading=()=>{
    return(
        <>
            <div class="lds-dual-ring"></div>
        </>
    )
}

export default Loading